import { Component } from "react";
import { compose } from "redux";

import CircularProgress from "@material-ui/core/CircularProgress";
import Slider from "@material-ui/core/Slider";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

import PropTypes from "prop-types";

import ApiButton from "../../../shared/ui/Api.Button";
import { settingsConnector } from "../../../services/settings/connector";

class SettingsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { sessionMinutes: 30 };
  }

  componentDidMount() {
    this.props.getUserData();
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    if (
      props.settings.userData.fetched &&
      props.settings.userData.data.SessionMinutes
    ) {
      this.setState({
        sessionMinutes: props.settings.userData.data.SessionMinutes,
      });
    }
  };

  changeMinutes = (event) => {
    let value = event.target.value;
    if (value < 0) value = 0;
    else if (value > 480) value = 480;

    this.setState({
      sessionMinutes: value,
    });
  };

  checkMinutes = (event) => {
    if (event.target.value < 3)
      this.setState({
        sessionMinutes: 3,
      });
  };

  setSession = () => {
    this.props.setSessionMinutes(this.state.sessionMinutes);
  };

  render() {
    return (
      <div className="settings-layout body-height content-padding">
        <div className="row">
          <div className="col-md-12">
            <h3>Settings management</h3>
            <div className="settings-session">
              <h4>Session time set (3 - 480 minutes)</h4>
              {this.props.settings.userData.fetching ? (
                <CircularProgress />
              ) : this.props.settings.userData.fetched ? (
                <div style={{ textAlign: "center" }}>
                  <Slider
                    step={1}
                    value={this.state.sessionMinutes}
                    max={480}
                    min={3}
                    onChange={this.changeMinutes}
                  />
                  <div>
                    <TextField
                      size="small"
                      variant="outlined"
                      id={"session-minutes"}
                      value={this.state.sessionMinutes}
                      onChange={this.changeMinutes}
                      onBlur={this.checkMinutes}
                      type={"number"}
                    />
                  </div>
                  <div>
                    <ApiButton
                      buttonLabel={"Set session"}
                      sending={this.props.settings.sessionMinutes.sending}
                      sent={this.props.settings.sessionMinutes.sent}
                      error={this.props.settings.sessionMinutes.error}
                      onButtonClick={this.setSession}
                    />
                  </div>
                </div>
              ) : undefined}
              <Button
                variant="contained"
                color="primary"
                onClick={this.props.refreshToken}
              >
                {" "}
                refresh Token
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  static propTypes = {
    settings: PropTypes.object.isRequired,
    setSessionMinutes: PropTypes.func.isRequired,
    getUserData: PropTypes.func.isRequired,
  };
}
export default compose(settingsConnector)(SettingsComponent);
